






















































































































import _ from "lodash"
import { Vue, Component, Prop } from "vue-property-decorator"
import CXService from "@/services/cx"
import { cx } from "@/types"
import { COUNTRY_OPTIONS } from "@/services/salesforce/types/constants"

@Component({
  name: "new-location-dialog",
})
export default class NewLocationDialog extends Vue {
  cxService: CXService = new CXService()
  COUNTRY_OPTIONS = COUNTRY_OPTIONS
  loading: boolean = false
  complete: boolean = false
  error: string | null = null
  newLocationValid: boolean = false
  advancedEditVisible: boolean = false
  description: string | null = null
  address: string | null = null
  country: string | null = null
  city: string | null = null
  state: string | null = null
  postalCode: string | null = null
  phoneNumber: string | null = null
  attn: string | null = null
  $refs!: {
    newLocationForm: any
  }

  maxLength = (length: number) => {
    return (v: string) => {
      return v?.length <= length || `Max ${length} characters`
    }
  }

  poBoxRule = (v: string) => {
    return !v.match(/^.*(?:(?:po box)|(?:post office box)|(?:p\.o\.)).*$/gim) || "Address cannot be a PO Box"
  }

  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: String, default: "New Location", required: false }) readonly title!: string
  @Prop({ type: Number, required: true }) readonly accountId!: number

  get formattedAddress(): string {
    return [this.address, this.city, this.state, this.postalCode, this.country].filter(v => v).join(", ")
  }

  get statusHtml(): string {
    if (this.isLoading && !this.isComplete) {
      return `Creating <strong>${this.description}</strong>...`
    } else {
      if (this.isComplete) {
        if (this.hasError) {
          return `<strong>${this.error}</strong>`
        } else {
          return `<strong>${this.description}</strong> Created!`
        }
      } else {
        return ""
      }
    }
  }

  get isLoading(): boolean {
    return this.loading
  }

  get isComplete(): boolean {
    return this.complete || this.hasError
  }

  get hasError(): boolean {
    return !_.isNil(this.error)
  }

  hasStates(countryVal: string | null): boolean {
    if (!_.isNil(countryVal)) {
      let country = COUNTRY_OPTIONS.findIndex(country => country.value === countryVal)
      if (country > -1) {
        return !_.isNil(COUNTRY_OPTIONS[country].states)
      }
    }
    return false
  }

  getStates(countryVal: string | null) {
    if (!_.isNil(countryVal)) {
      let country = COUNTRY_OPTIONS.findIndex(country => country.value === countryVal)
      if (country > -1) {
        return COUNTRY_OPTIONS[country].states || []
      }
    }
    return []
  }

  hideDialog(): void {
    this.$refs.newLocationForm.reset()
    this.$emit("update:value", false)
    this.loading = false
    this.complete = false
    this.error = null
  }

  async createLocation(location: cx.Returns.Location): Promise<number> {
    let locationData: cx.Returns.Location = _.clone(location)
    try {
      return await this.cxService.getLocationId(locationData)
    } catch (err) {
      return await this.cxService.createLocation(locationData)
    }
  }

  async create(): Promise<void> {
    this.error = null
    this.complete = false
    this.loading = true
    try {
      let locationId: number = await this.createLocation({
        description: this.description,
        address: this.address,
        country: this.country,
        city: this.city,
        state: this.state,
        postalCode: this.postalCode,
        phoneNumber: this.phoneNumber,
        attn: this.attn,
      } as cx.Returns.Location)

      await this.cxService.createAccountLocationMapping(this.accountId, locationId)
      this.loading = false
      this.complete = true
      this.$emit("location-created", locationId)
    } catch (error) {
      this.loading = false
      this.$raven.captureException(error)
      this.error = error
    }
  }
}
